export default {
  heading: "'Nunito Sans', sans-serif",
  body: "'Nunito Sans', sans-serif",
};
